export enum PluginStatusEnum {
  NEEDS_SETUP = 'NEEDS_SETUP',
  ACTIVE = 'ACTIVE',
  ACTIVE_WITH_WARNINGS = 'ACTIVE_WITH_WARNINGS',
  INACTIVE = 'INACTIVE',
  NEEDS_REAUTHENTICATION = 'NEEDS_REAUTHENTICATION',
  ERROR = 'ERROR'
}
